import { AbstractControl, FormGroup } from '@angular/forms';
import { of, OperatorFunction, pipe } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  skip,
  startWith,
  switchMap,
} from 'rxjs/operators';

export function controlValid(): OperatorFunction<
  AbstractControl | null | undefined,
  boolean
> {
  return pipe(
    switchMap(
      (control: AbstractControl | null | undefined) =>
        control?.statusChanges.pipe(
          filter(() => control.enabled),
          map(() => control.valid),
          startWith(control.valid)
        ) ?? of(false)
    ),
    distinctUntilChanged()
  );
}

export function controlValidityChanges(): OperatorFunction<
  FormGroup | null | undefined,
  boolean
> {
  return pipe(controlValid(), skip(1));
}
